import { ICommand } from 'core-ts-types';
import * as _4 from 'lodash4';
import { PlatformUtility } from 'utility-ts-platform';
import { ScheduleQuery } from './queries/schedule_query';

export function ScheduleRoutes($stateProvider: ng.ui.IStateProvider) {
  $stateProvider
    .state('my.courseSchedule', {
      url: 'course_schedule/',
      template: PlatformUtility.isMobile() ? `<ion-nav-view></ion-nav-view>` : `<ui-view></ui-view>`,
      abstract: true,
      resolve: {
        courses: (ngScheduleQuery: ScheduleQuery, courseListCommand: ICommand) => {
          if (_4.isEmpty(ngScheduleQuery.result)) {
            courseListCommand().then(() => false);
          }
        }
      }
    })
    .state('my.courseSchedule.term', {
      url: 'term/:term',
      templateUrl: 'capability-ng-course-schedule/src/views/my_schedule_list_view/my_schedule_list_view.html',
      controller: 'MyScheduleListViewController',
      controllerAs: '$ctrl',
      data: {
        viewTitle: 'Class Schedule',
        hasMainMenu: true,
        ignoredInHistory: false
      },
      params: {
        viewType: ''
      }
    })
    .state('my.courseSchedule.detail', {
      url: 'detail/:id',
      templateUrl: 'capability-ng-course-schedule/src/views/my_schedule_detail_view/my_schedule_detail_view.html',
      controller: 'MyScheduleDetailViewController',
      controllerAs: '$ctrl',
      data: {
        viewTitle: 'Class Details',
        ignoredInHistory: false
      },
      resolve: {
        __course: (courseDetailCommand: ICommand, $stateParams: ng.ui.IStateParamsService) => {
          return courseDetailCommand($stateParams.id).then((course: any) => course);
        }
      }
    });
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-course-schedule/src/routes.ts